<template>
  <div class="order-detail">
    <div class="detail-content">
      <div class="header-title">
        <h2>订单编号：{{paymentOrderId}}</h2>
      </div>
      <div class="info" v-for="(item, index) in info" :key="index">
        <div class="info-title">
          <span class="icon"></span>
          <span class="info-title-text">{{item.title}}</span>
        </div>
        <ul>
          <el-row v-for="(rowItem, rowIndex) in item.infoRow" :key="rowIndex">
            <template v-for="(liItem,liIndex) in rowItem.li">
              <li class="info-item" v-if="liItem.showStatus.includes(status)" :key="liIndex">
                <span class="label">{{liItem.label}}</span>
                <span v-if="liItem.key == 'phone'" class="value">
                  {{liItem.value}}
                  <auth-button auth="user:phone:read">
                    <el-button v-if="!showPhone" type="text" class="look-phone" @click="onLookPhone(true, {index, rowIndex, liIndex})">查看</el-button >
                    <el-button v-if="showPhone" type="text" class="look-phone" @click="onLookPhone(false, {index, rowIndex, liIndex})">隐藏</el-button >
                  </auth-button>
                </span>
                <span v-else class="value">
                  {{liItem.isTime ? (liItem.value ? $moment(liItem.value).format('YYYY/MM/DD HH:mm:ss') : '') : (liItem.value || liItem.value === 0 ? liItem.value : '-')}}
                  {{(liItem.value || liItem.value === 0) && ['amount', 'coupon', 'pointDiscountAmount', 'virtualCardAmount', 'actualAmount'].includes(liItem.key) ? '元' : ''}}
                  {{(liItem.value || liItem.value === 0) && ['point'].includes(liItem.key) ? '分' : ''}}
                </span>
              </li>
            </template>
          </el-row>
          <el-row v-if="orderDetail.productType == 'Recharge' || orderDetail.productType == 'WelfareCoupon'">
            <li class="info-item">
              <span class="label">商品类型：</span>
              <span class="value">{{ orderDetail.productType == 'Recharge' ? '充值' : '福利券' }}</span>
            </li>
            <li class="info-item">
              <span class="label">商品名称：</span>
              <span class="value">{{ orderDetail.productName }}</span>
            </li>
            <li class="info-item" v-if="orderDetail.productType != 'WelfareCoupon'">
              <span class="label">直充账号：</span>
              <span class="value">{{ orderDetail.rechargeAccount }}</span>
            </li>
          </el-row>
          <el-divider></el-divider>
          <div v-if="orderDetail.deductionList&&orderDetail.deductionList.length != 0">
              <div class="info-title">
                <span class="icon"></span>
                <span class="info-title-text">抵扣信息</span>
              </div>
              <div class="coupon-table" style="margin-left: 0; width: 800px;" >
                <Table
                  :tableThData="deduction_tableThData"
                  :tableTrData="orderDetail.deductionList"
                  :pagination="false"
                >
                  <template #deductionType="{ row }">{{ row.deductionType}}</template>
                  <template #deductionName="{ row }">{{ row.deductionName }}</template>
                  <template #deductionAmount="{ row }">{{ row.deductionAmount }}元</template>
                </Table>
              </div>
              <el-divider></el-divider>
          </div>
          <div v-if="refundList">
            <div class="info-title" >
              <span class="icon"></span>
              <span class="info-title-text">退款信息</span>
              <span class="hint" v-if="showPartRefundHint">（退款处理中, 预计1到3个工作日到账）</span>
            </div>
            <el-row v-for="(rowItem) in refundList" :key="rowItem.refundOrderId">
              <li class="info-item">
                <span class="label">退款金额：</span>
                <span class="value">
                  {{rowItem.amount}}
                </span>
              </li>
              <li class="info-item">
                <span class="label">退款时间：</span>
                <span class="value">
                  {{rowItem.finishTime ? $moment(rowItem.finishTime).format('YYYY/MM/DD HH:mm:ss') : ''}}
                </span>
              </li>
              <li class="info-item">
                <span class="label">退款订单号：</span>
                <span class="value">
                  {{rowItem.refundOrderId}}
                </span>
              </li>
              <li class="info-item">
                <span class="label">退款状态：</span>
                <span class="value">
                  {{rowItem.status == 'Success' ? '已退款' : '退款中'}}
                </span>
              </li>
            </el-row>
            <el-divider></el-divider>
          </div>
        </ul>

        <div class="info-title" v-if="orderDetail.commissionInfo&&orderDetail.commissionInfo.inviter">
          <span class="icon"></span>
          <span class="info-title-text">分销信息</span>
        </div>
        <ul v-if="orderDetail.commissionInfo&&orderDetail.commissionInfo.inviter">
          <el-row>
            <li class="info-item">
              <span class="label">一级分佣对象：</span>
              <span class="value">
                  {{ orderDetail.commissionInfo.showPhoneInviter || orderDetail.commissionInfo.inviter }}
                  <auth-button auth="user:phone:read">
                    <el-button type="text" class="look-phone" @click="onLookPhoneInviter('showPhoneInviter',orderDetail.commissionInfo.inviterId)">{{ showPhoneInviter ? '隐藏' : '查看'}}</el-button >
                  </auth-button>
                </span>
            </li>
            <li class="info-item">
              <span class="label" style="width: 210px;">应发佣金金额（元）：</span>
              <span class="value">{{ orderDetail.commissionInfo.commission ? orderDetail.commissionInfo.commission : '-' }}</span>
            </li>
          </el-row>
          <el-row>
            <li class="info-item">
              <span class="label">结算方式：</span>
              <span class="value">{{ orderDetail.commissionInfo.commissionSettleType }}</span>
            </li>
            <li class="info-item">
              <span class="label" style="width: 210px;">实发佣金金额（元）：</span>
              <span class="value">{{ orderDetail.commissionInfo.settledCommission ?  orderDetail.commissionInfo.settledCommission : '-'}}</span>
            </li>
          </el-row>
        </ul>
        <ul v-if="orderDetail.commissionInfo&&orderDetail.commissionInfo.secondaryInviter">
          <el-row>
            <li class="info-item" >
              <span class="label">二级分佣对象：</span>
              <span class="value">
                  {{ orderDetail.commissionInfo.showPhoneSecondaryInviter || orderDetail.commissionInfo.secondaryInviter }}
                  <auth-button auth="user:phone:read">
                    <el-button type="text" class="look-phone" @click="onLookPhoneInviter('showPhoneSecondaryInviter',orderDetail.commissionInfo.secondaryInviterId)">{{ showPhoneSecondaryInviter ? '隐藏' : '查看' }}</el-button >
                  </auth-button>
                </span>
            </li>
            <li class="info-item">
              <span class="label" style="width: 210px;">应发二级佣金金额（元）：</span>
              <span class="value">{{ orderDetail.commissionInfo.secondaryCommission ? orderDetail.commissionInfo.secondaryCommission : '-' }}</span>
            </li>
          </el-row>
          <el-row>
            <li class="info-item">
              <span class="label">结算方式：</span>
              <span class="value">{{ orderDetail.commissionInfo.commissionSettleType }}</span>
            </li>
            <li class="info-item">
              <span class="label" style="width: 210px;">实发二级佣金金额（元）：</span>
              <span class="value">{{ orderDetail.commissionInfo.settledSecondaryCommission ?  orderDetail.commissionInfo.settledSecondaryCommission : '-'}}</span>
            </li>
          </el-row>
        </ul>
        <ul v-if="orderDetail.commissionInfo&&orderDetail.commissionInfo.userInviter">
          <el-row>
            <li class="info-item">
              <span class="label">直接邀请人：</span>
              <span class="value">
                  {{ orderDetail.commissionInfo.showPhoneUserInviter || orderDetail.commissionInfo.userInviter }}
                  <auth-button auth="user:phone:read">
                    <el-button type="text" class="look-phone" @click="onLookPhoneInviter('showPhoneUserInviter',orderDetail.commissionInfo.userInviterId)">{{ showPhoneUserInviter ? '隐藏' : '查看' }}</el-button >
                  </auth-button>
                </span>
            </li>
            <li class="info-item">
              <span class="label" style="width: 210px;">应发直接邀请人佣金金额（元）：</span>
              <span class="value">{{ orderDetail.commissionInfo.userInviterCommission ? orderDetail.commissionInfo.userInviterCommission : '-' }}</span>
            </li>
          </el-row>
          <el-row>
            <li class="info-item">
              <span class="label">结算方式：</span>
              <span class="value">{{ orderDetail.commissionInfo.userInviterCommissionSettleType }}</span>
            </li>
            <li class="info-item">
              <span class="label" style="width: 210px;">实发直接邀请人佣金金额（元）：</span>
              <span class="value">{{ orderDetail.commissionInfo.settledUserInviterCommission ?  orderDetail.commissionInfo.settledUserInviterCommission : '-'}}</span>
            </li>
          </el-row>
        </ul>
      </div>
    </div>
    <div class="footer">
      <el-button type="default" @click="goback">返回</el-button>
    </div>
  </div>
</template>

<script>
import Table from "@/components/Table/index";
import AuthButton from '@/components/AuthButton'
import { api_getOrder } from '@/api/order'
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
export default {
  name: "orderDetail",
  components: {
    AuthButton,
    Table
  },
  data() {
    return {
      userId: '',
      phone: '',
      showPhone: false,
      showPhoneInviter: false,
      showPhoneSecondaryInviter: false,
      showPhoneUserInviter: false,
      showPartRefundHint: false,
      info: [{
        title: '基础信息',
        infoRow: [{
          li: [{
            label: '订单状态：',
            value: '待付款/已付款',
            key: 'status',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund']
          },{
            label: '交易流水号：',
            value: '',
            key: 'transactionId',
            showStatus: ['Doing', 'PaymentSuccess', 'Refund', 'PartRefund']
          },{
            label: '消费店铺：',
            value: '',
            key: 'storeName',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund']
          },{
            label: '订单来源：',
            value: '',
            key: 'source',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund']
          }]
        },{
          li: [{
            label: '会员手机号：',
            value: '',
            key: 'phone',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund']
          },{
            label: '订单金额：',
            value: '',
            key: 'amount',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund']
          },{
            label: '实付金额：',
            value: '',
            key: 'actualAmount',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund']
          }]
        },{
          li: [{
            label: '储值卡抵扣：',
            value: '',
            key: 'virtualCardAmount',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund']
          },{
            label: '优惠券抵扣：',
            value: '',
            key: 'coupon',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund']
          },{
            label: '积分抵扣：',
            value: '',
            key: 'pointDiscountAmount',
            showStatus: ['PaymentSuccess', 'Refund', 'PartRefund']
          }]
        },{
          li: [{
            label: '获得积分：',
            value: '',
            key: 'point',
            showStatus: ['Doing', 'PaymentSuccess', 'Refund', 'PartRefund']
          },{
            label: '创建时间：',
            value: '',
            key: 'created',
            showStatus: ['Doing', 'Canceled', 'PaymentSuccess', 'Refund', 'PartRefund'],
            isTime: true
          },{
            label: '交易时间：',
            value: '',
            key: 'payTime',
            showStatus: ['Doing', 'PaymentSuccess', 'Refund', 'PartRefund'],
            isTime: true
          },{
            label: '取消时间：',
            value: '',
            key: 'cancelTime',
            showStatus: ['Canceled'],
            isTime: true
          }]
        },{
          li: [{
            label: '退款金额：',
            value: '0',
            key: 'refundAmount',
            showStatus: ['']
          },{
            label: '退款时间：',
            value: '',
            key: 'refundTime',
            showStatus: [''],
            isTime: true
          },{
            label: '退款订单号：',
            value: '',
            key: 'refundOrderId',
            showStatus: ['']
          },{
            label: '退款状态：',
            value: '',
            key: 'status',
            showStatus: ['']
          }]
        }]
      }],
      deduction_tableThData:[
        { prop: "deductionType", label: "抵扣类型", minWidth: "110", },
        { prop: "deductionName", label: "优惠券名称", minWidth: "110", },
        { prop: "deductionAmount", label: "抵扣金额", minWidth: "110", },
      ],
      paymentOrderId: '',
      status: '',
      refundList: [],
      orderDetail: {}
    };
  },
  created () {
    this.getOrderDetail()
  },
  methods: {
    async getOrderDetail () {
      const data = await api_getOrder({id: this.$route.query.id})
      this.orderDetail = data
      this.paymentOrderId = data.paymentOrderId
      this.status = data.status
      this.refundList = data.refundList
      this.phone = data.phone
      this.userId = data.userId
      this.showPartRefundHint = this.refundList && this.refundList.findIndex(item => item.status === 'Doing') >= 0
      this.info.forEach((item) => {
        item.infoRow.forEach((infoRowItem) => {
          infoRowItem.li.forEach((liItem) => {
            liItem.value = data[liItem.key]
            if(liItem.key == 'status'){
              liItem.value = this.formatStatus(data[liItem.key])
            }
          })
        })
      })
    },
    goback () {
      this.$router.go(-1)
    },
    // 点击查看手机号
    async onLookPhone(show, {index, rowIndex, liIndex}) {
      this.showPhone = show
      if(show){
        try {
          const {phone} = await api_getUserPhone({id: this.userId})
          this.info[index].infoRow[rowIndex].li[liIndex].value = aes.decrypt(phone)
        } catch (error) {}
      }else{
        this.info[index].infoRow[rowIndex].li[liIndex].value = this.phone
      }
      this.$forceUpdate()
    },
    // 分销信息手机号查看
    async onLookPhoneInviter(show,id) {
        try {
          if (!this[show]) {
            const {phone} = await api_getUserPhone({id})
            this.orderDetail.commissionInfo[show] = aes.decrypt(phone)
          }else{
           delete this.orderDetail.commissionInfo[show] 
          }
          this[show] = !this[show]
        } catch (error) {
          console.log(error)
        }
      this.$forceUpdate()
    },
    formatStatus (status) {
      switch (status) {
        case 'Doing':
          return '待付款'
        case 'Canceled':
          return '已取消'
        case 'PaymentSuccess':
          return '已付款'
        case 'Refund':
          return '已退款'
        case 'PartRefund':
          return '部分退款'
      }
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.order-detail {
  padding: 0 20px;
  padding-bottom: 80px;
  // min-width: 1162px;
  // overflow-x: auto;
  .detail-content{
    .header-title{
      height: 84px;
      border-bottom: 1px solid #ccc;
      h2{
        line-height: 84px;
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        margin: 0;
      }
    }
    .info{
      margin-top: 30px;
      padding-bottom: 30px;
      border-bottom: 1px solid #ccc;

      .el-divider {
        margin: 50px 0;
      }

      .info-title{
        display: flex;
        align-items: center;
        .icon{
          width: 5px;
          height: 25px;
          background: #05C8AF;
          border-radius: 2px;
          display: inline-block;
        }
        .info-title-text{
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 28px;
          height: 25px;
          margin-left: 10px;
        }
      }
      ul{
        margin: 0;
        padding: 0;
        .info-item{
          margin: 0;
          padding: 0;
          list-style: none;
          margin-top: 30px;
          font-size: 14px;
          color: #666;
          display: inline-block;
          .label{
            width: 100px;
            text-align: right;
            display: inline-block;
          }
          .value{
            width: 200px;
            display: inline-block;
            color: #333;
            font-weight: 500;
            vertical-align: middle;
            button{
              padding: 0;
              margin-left: 10px;
            }
            .look-phone{
              font-size: 12px;
              color: #1a5cf5;
              margin-left: 0;
            }
          }
        }
      }
    }
    .info:last-child{
      border: 0;
    }
  }
  .footer{
    position: fixed;
    bottom: 0;
    height: 80px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    padding-left: 70px;
    padding-top: 23px;
    box-sizing: border-box;
    bottom: 0;
    button{
      padding: 0;
      height: 34px;
      text-align: center;
      width: 110px;
      font-size: 16px;
      color: #666666;
      border: 0;
    }
  }
}
</style>
